// Κινήσεις ταμείου: ετικέτες, πρόσημα και η ανάγνωση του ποσού που πληκτρολογεί ο ταμίας.

import type { CashMovement, CashMovementKind, CashMovementsTotals } from '../../../types/registerReport';

export const KIND_ORDER: CashMovementKind[] = ['expense', 'withdrawal', 'deposit'];

export const KIND_META: Record<CashMovementKind, { label: string; hint: string; out: boolean }> = {
  expense: { label: 'Έξοδο', hint: 'Πληρωμή από το συρτάρι (προμηθευτής, αναλώσιμα…)', out: true },
  withdrawal: { label: 'Ανάληψη', hint: 'Πήραν μετρητά από το συρτάρι (π.χ. ο ιδιοκτήτης)', out: true },
  deposit: { label: 'Κατάθεση', hint: 'Μπήκαν μετρητά στο συρτάρι (π.χ. ρέστα)', out: false },
};

/**
 * «12,50» / «12.5» / «7» → λεπτά· null για ό,τι δεν είναι θετικό ποσό ως 2 δεκαδικά. Ίδιος κανόνας με τον
 * server (services/cashMovements parseAmountCents).
 */
export function parseAmountInput(raw: string): number | null {
  const s = String(raw || '').trim().replace(/\s+/g, '').replace(',', '.');
  if (!/^\d+(\.\d{1,2})?$/.test(s)) return null;
  const cents = Math.round(Number(s) * 100);
  return Number.isFinite(cents) && cents > 0 ? cents : null;
}

/** Λεπτά → «12.50» για το API. */
export const centsToApi = (cents: number) => (cents / 100).toFixed(2);

/** Μοναδικό κλειδί ανά άνοιγμα της φόρμας ([A-Za-z0-9_-], όπως θέλει ο server). */
export function newClientKey(): string {
  const rnd = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID().replace(/-/g, '')
    : `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
  return `cm_${rnd}`.slice(0, 64);
}

/** Θετικό για ό,τι μπαίνει στο συρτάρι, αρνητικό για ό,τι βγαίνει. */
export const drawerSign = (m: Pick<CashMovement, 'kind'>) => (KIND_META[m.kind]?.out ? -1 : 1);

/** Τα σύνολα όταν η αναφορά δεν τα φέρνει (δεν συμβαίνει με σημερινό backend — θωράκιση). */
export function totalsOf(items: CashMovement[]): CashMovementsTotals {
  const t: CashMovementsTotals = {
    deposit: 0, expense: 0, withdrawal: 0,
    counts: { deposit: 0, expense: 0, withdrawal: 0 },
    voided: { count: 0, value: 0 },
  };
  for (const m of items) {
    if (m.voidedAt) { t.voided.count += 1; t.voided.value += m.amount; continue; }
    t[m.kind] += m.amount;
    t.counts[m.kind] += 1;
  }
  return t;
}
